import React from 'react';

import { ReferenceInput } from 'react-admin';
import { AutocompleteInput } from 'ra-ui-materialui/lib/input/AutocompleteInput';


const defaultSort = {
    field: "id",
    order: "ASC"
};


export const TimeZoneSelect = ({ size, source, ...props }) => {
    return (
        <ReferenceInput 
            perPage={15}
            {...props} 
            sort={defaultSort} 
            source={source} 
            reference="time-zones" 
            filter={{ no_range: false, ...props.filter }}
        >
            <AutocompleteInput 
                optionText="zone"
                optionValue="zone"
                resettable 
                options={{ InputProps: { size } }} 
            />
        </ReferenceInput>
    );
};
